module.exports = __webpack_public_path__ + "static/media/TiempoLimite.fa2b8d59.svg";